module.exports = __webpack_public_path__ + "b391f517930912a20be2f0eb3fdc156a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/img_ELDAR_W_633px_H_660px.jpg
// module id = 394
// module chunks = 0